module.exports = __webpack_public_path__ + "static/garnet-5df5729fbab9087c68a19091e96b27fd.svg";